import { Link } from "react-router";
import { Pages } from "../../../utils";

export const DualCtaSection = () => {
  return (
    <section className="dual">
      <div className="cp cp-ho fi">
        <div>
          <div className="cp-ey">For Homeowners</div>
          <h2 className="cp-h">
            Stop searching. Start living in <em>the home you deserve.</em>
          </h2>
          <p className="cp-p">
            Whether you're searching for interior designers near you or starting
            a full home renovation, Home Design Guild matches you with a
            vetted, HDG authorized interior designer who is the right fit — the
            first time.
          </p>
        </div>
        <div className="cp-btns">
          <Link to={`${Pages.SIGNUP}?userType=Homeowner`} className="cp-b1">
            Find My Match →
          </Link>
          <Link to={`${Pages.HOMEOWNER_USER_LANDING}#why-join`} className="cp-b2">
            Why Join Home Design Guild →
          </Link>
        </div>
        <div className="cp-wm">H</div>
      </div>

      <div className="cp cp-ds fi">
        <div>
          <div className="cp-ey">For Interior Designers</div>
          <h2 className="cp-h">
            Join a network built for <em>distinguished designers.</em>
          </h2>
          <p className="cp-p">
            Apply for HDG authorization and connect with qualified homeowners
            whose projects and personalities are the right fit for your
            practice — no cold leads, no unvetted inquiries.
          </p>
        </div>
        <div className="cp-btns">
          <Link to={Pages.JOIN_AS_DESIGNER} className="cp-b1">
            Apply for Authorization →
          </Link>
          <Link to={`${Pages.ABOUT_US_PAGE}#the-seal`} className="cp-b2">
            About the HDG Seal of Approval →
          </Link>
        </div>
        <div className="cp-wm">D</div>
      </div>
    </section>
  );
};
